// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { TrapFocusService } from '@client/app/modules/trap-focus/trap-focus.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-qa-ignored-spell',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fas fa-fw fa-language mr-2 text-link mt-1" aria-hidden="true"></span>
            <div>
                <h2 class="font-weight-300 mb-0" translate>
                    Ignored Misspellings
                </h2>
                @let total = misspellings.total | monNumber;
                <span class="text-grey" translate [translate-n]="total"
                      translate-plural="[[$count]] words found">
                    1 word found
                </span>
            </div>
        </div>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        [collection]="misspellings"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="promise"
                        [noResultMessage]="noResultMessage">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th class="col-40" [attr.aria-label]="wordLabel" translate>
                                Word
                            </th>
                            <th class="col-8 text-right">
                                &nbsp;
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let misspelling of misspellings; trackBy: trackByMisspellingId">
                            <td [attr.aria-label]="misspelling.word">
                                {{misspelling.word}}
                            </td>
                            <td class="text-right" [attr.aria-label]="unignoreLabel">
                                <button class="btn btn-border-radius btn-secondary"
                                        monEventTrigger="actionTrigger"
                                        [monEventParams]="{action: 'unignore-misspelling-btn'}"
                                        (click)="confirmRemoveIgnoredMisspelling(misspelling)" translate>
                                    Unignore misspelling
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageDetailsSectionQaIgnoredSpellComponent extends BaseContainerComponentController implements OnInit {
    @Input() activePage: any;
    @Input() type: string = '';
    @Input() headline?: string;
    @Output() refreshPage = new EventEmitter<void>();

    misspellings: any = [];
    promise: any;
    override page: number = 1;
    override pageSize: number = 10;
    override search: string = '';
    noResultMessage: string = '';
    wordLabel: string = '';
    unignoreLabel: string = '';

    constructor (
        private monModalService: MonModalService,
        private translateService: TranslateService,
        private trapFocusService: TrapFocusService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.search = '';
        this.misspellings = [];
        this.noResultMessage = this.translateService.getString('No ignored misspellings found for this page');
        this.wordLabel = this.translateService.getString('Word');
        this.unignoreLabel = this.translateService.getString('Unignore misspelling');
        this.getPage();
    }

    override getPage = (): void => {
        const params = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search ?? '',
        };
        this.promise = this.spellingRepoService.getAllIgnoredPageSpellingErrors(this.activePage.id, params)
            .then((misspellings: any) => {
                this.misspellings = misspellings;
            }, () => {});
    };

    confirmRemoveIgnoredMisspelling (misspelling: any): void {
        const params = {
            title: this.translateService.getString('Are you sure you want to unignore this misspelling?'),
            message: this.translateService.getString('The misspelling will first show up after a new scan'),
            buttons: [
                {
                    label: this.translateService.getString('Cancel'),
                    className: 'btn btn-secondary',
                    callback: () => {
                        this.trapFocusService.unPauseLast();
                    },
                    value: 'cancel',
                },
                {
                    label: this.translateService.getString('Ok'),
                    className: 'btn btn-primary',
                    callback: () => {
                        this.removeIgnoredMisspelling(misspelling);
                        this.trapFocusService.unPauseLast();
                    },
                    value: 'success',
                },
            ],
        };
        this.monModalService.customDialog(params, {});
    }

    removeIgnoredMisspelling (misspelling: any): void {
        this.spellingRepoService.destroyIgnoredPageSpellingError(this.activePage.id, misspelling.id)
            .then(() => {
                this.getPage();
            }, () => {});
    }

    trackByMisspellingId (index: number, misspelling: any): any {
        return misspelling.id;
    }
}
